import { render, staticRenderFns } from "./PSummaryCard.vue?vue&type=template&id=692d9e87&scoped=true&"
import script from "./PSummaryCard.vue?vue&type=script&lang=js&"
export * from "./PSummaryCard.vue?vue&type=script&lang=js&"
import style0 from "./PSummaryCard.vue?vue&type=style&index=0&id=692d9e87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692d9e87",
  null
  
)

export default component.exports